import { Factory } from 'miragejs'

export default Factory.extend({
  status: 'busy',
})
